import { render, staticRenderFns } from "./PartsForm.vue?vue&type=template&id=39521f79&scoped=true"
import script from "./PartsForm.vue?vue&type=script&lang=js"
export * from "./PartsForm.vue?vue&type=script&lang=js"
import style0 from "./PartsForm.vue?vue&type=style&index=0&id=39521f79&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39521f79",
  null
  
)

export default component.exports